import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import './assets/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from "react-redux";
import {store, IntlProvider} from "./_library";

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
    <StrictMode>
        <Provider store={store}>
            <IntlProvider>
                <App />
            </IntlProvider>
        </Provider>
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
